import AvgHeartRate from "../../assets/images/png/avgHeartRate.png";
import Sleep from "../../assets/images/png/sleep.png";
import CaloriesBurned from "../../assets/images/png/caloriesBurned.png";
import ExerciseTime from "../../assets/images/png/exerciseTime.png";
import FemaleAthlete from "../../assets/images/jpeg/appleHealthImg.jpg";
import Steps from "../../assets/images/png/steps.png";

import VerticalGap from "../../components/VerticalGap";

import "./index.scss";

const TrackActivities = () => (
  <div className="track-activities">
    <div className="track-uper">
      <div className="sub-heading">Track your activites</div>
      <div className="heading">Apple Health Kit & Google Fit</div>
    </div>
    <VerticalGap />
    <div className="track-bottom">
      <div className="track-left">
        <img src={FemaleAthlete} className="image" alt="Female Athlete" />
      </div>
      <div className="track-right">
        <div className="row-one">
          <img src={AvgHeartRate} className="image" alt="heart rate" />
        </div>
        <div className="row-two">
          <img src={CaloriesBurned} className="image image-left" alt="calories burned" />
          <img src={Sleep} className="image" alt="sleep" />
        </div>
        <div className="row-three">
          <img src={ExerciseTime} className="image image-left" alt="calories burned" />
          <img src={Steps} className="image" alt="steps" />
        </div>
      </div>
    </div>
    <div className="track-lower">
      <div className="text">
        Track all of your activities in one place by syncing your app with Apple Health Kit or Google Fit, making it
        easier to hit your daily exercise goals.
      </div>
    </div>
  </div>
);

export default TrackActivities;
